import { http } from "../../../../../../mainDi/webDi";
import actions from "./actions";
import presenters from "./presenters";
import repositories from "./repositories";
import useCases from "./useCases";
var cRepositorires = repositories(http);
var cUseCases = useCases(cRepositorires);
var cActions = actions();
var cPresenters = presenters(cUseCases, cActions);
export default cPresenters;
